export const UploadCloud = ({ size = 16, color = 'currentColor' }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.9583 12.9998H12C13.7677 12.9998 15 11.7278 15 10.1427C15 8.86043 14.1862 7.61518 12.9843 7.32459C12.9433 6.27406 12.477 5.48956 11.8332 5.07578C11.202 4.66995 10.4223 4.62065 9.73433 4.93067C9.1827 3.86493 8.09549 3 6.66647 3C4.54081 3 3.04265 4.98911 3.15099 7.01783C1.91738 7.34717 1 8.54308 1 9.96418C1 11.6387 2.27048 12.9998 3.83331 12.9998H5"
        stroke={color}
        strokeLinecap="round"
      />
      <path d="M8 8V14.5M8 8L5.5 10.5M8 8L10.5 10.5" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export default UploadCloud
